import { UiNavBlogArticleModel } from "../../models";

import {
    mockLinkButtonThemeModel,
    mockLinkButtonThemeModelContent,
    mockUiButtonModel,
    mockUiButtonModelContent,
    mockUiLinkModel,
    mockUiLinkModelContent,
    mockUiNavBannerModel,
    mockUiNavBannerModelContent
} from ".";

export function mockUiNavBlogArticleModel({
    id = "ui-nav-blog-article-1234",
    type = "uiNavBlogArticle",
    locale = "en",
    content = mockUiNavBlogArticleModelContent()
}: Partial<UiNavBlogArticleModel> = {}): UiNavBlogArticleModel {
    return {
        id,
        type,
        locale,
        content
    };
}
export type UiNavBlogArticleModelContent = UiNavBlogArticleModel["content"];
export function mockUiNavBlogArticleModelContent({
    entryTitle = "Demo blog article",
    title = "Latest article",
    cta = mockUiLinkModel({
        content: mockUiLinkModelContent({
            url: "https://blog.trello.com/",
            text: "More articles"
        })
    }),
    fallback = mockUiNavBannerModel({
        content: mockUiNavBannerModelContent({
            titleHeading: "Helping teams work better, together",
            description:
                "Discover Trello use cases, productivity tips, best practices for team collaboration, and expert remote work advice.",
            button: mockUiButtonModel({
                content: mockUiButtonModelContent({
                    url: "https://blog.trello.com",
                    text: "Check out the Trello blog",
                    buttonTheme: mockLinkButtonThemeModel({
                        content: mockLinkButtonThemeModelContent({
                            appearance: "Purple",
                            style: "Outline"
                        })
                    })
                })
            })
        })
    })
}: Partial<UiNavBlogArticleModelContent> = {}): UiNavBlogArticleModelContent {
    return {
        entryTitle,
        title,
        cta,
        fallback
    };
}
